import { PaginationContainer, QueryParamsManager, Table } from "./components";

export function HistoryTab() {
    return (
        <>
            <Table />
            <PaginationContainer />
            <QueryParamsManager />
        </>
    )
}